const changeArrOrder = (
  arr: any[],
  id: string | undefined,
  action: "up" | "down"
) => {
  try {
    let index = arr.findIndex((ele) => id === ele[0].id); //対象の要素のインデックス番号(配列番号)を見つけるメソッド一致しなかったら-1を返す

    let changeFlag = 0; //移動フラグ
    if (action === "up" && index > 0) {
      //upかつindexが0以上の時
      changeFlag = index - 1; //移動フラグにindex-1した値を格納する
    } else if (action === "down" && index < arr.length - 1) {
      //downかつindexの数値が配列の長さ-1よりも小さいとき
      changeFlag = index + 1;
    } else {
      return arr;
    }

    let temSec = {}; //移動用
    temSec = arr[index]; //押下した番号を移動用に入れる
    arr[index] = arr[changeFlag]; //その下の配列を押下した番号の配列に詰める
    arr[changeFlag] = temSec; //押下した番号が入っている移動用のものを下の配列のやつに入れる
    return arr;
  } catch (error) {
    console.error(error);
  }
};

export { changeArrOrder };
